import convert from "color-convert";

const convert_rgb = convert.rgb;
const convert_hsl = convert.hsl;
const convert_hex = convert.hex;

export const getRandomColor = ():string => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}

export type RGB = [number,number,number];

export const afterOpacity = (fg: RGB,o: number,bg: RGB = [255,255,255]): RGB => {
    return fg.map((colFg,idx)=>o*colFg+(1-o)*bg[idx]) as RGB;
}

export const rgb2hex = (rgb: RGB): string => {
    return "#" + convert_rgb.hex(rgb);
}

export const hex2rgb = (hex: string): RGB => {
    return convert_hex.rgb(hex);
}

const unlogit = (x: number) => {
    const val = Math.max(0.001, Math.min(0.999, x));
    return Math.log(val / (1 - val));
}

const logit = (x: number) => {
    return 1 / (1 + Math.exp(-x));
}

export const lighten = (rgb: [number, number, number], ds: number, dl: number): RGB => {
    const hsl = convert_rgb.hsl(rgb);
    const l = 100 * logit(unlogit(hsl[2] / 100) + dl);
    const s = 100 * logit(unlogit(hsl[1] / 100) + ds);
    // console.log(JSON.stringify({hsl, l, s}))
    return convert_hsl.rgb([hsl[0], s, l]);
}
